import { __module as p } from "./ghl-ui.es1670.js";
import { i as S } from "./ghl-ui.es1498.js";
import { t as T } from "./ghl-ui.es1585.js";
import { r as U } from "./ghl-ui.es1591.js";
import { t as E } from "./ghl-ui.es1590.js";
import "./ghl-ui.es1592.js";
import { __exports as $ } from "./ghl-ui.es1595.js";
(function(O, o) {
  var a = S.default;
  Object.defineProperty(o, "__esModule", {
    value: !0
  }), o.default = g;
  var x = a(T), c = a(U), k = a(E), w = $;
  function g(C, e) {
    var l, i, n, d, s, u, f, v;
    (0, c.default)(1, arguments);
    var _ = (0, w.getDefaultOptions)(), r = (0, k.default)((l = (i = (n = (d = e == null ? void 0 : e.weekStartsOn) !== null && d !== void 0 ? d : e == null || (s = e.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : _.weekStartsOn) !== null && i !== void 0 ? i : (f = _.locale) === null || f === void 0 || (v = f.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && l !== void 0 ? l : 0);
    if (!(r >= 0 && r <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var t = (0, x.default)(C), m = t.getUTCDay(), D = (m < r ? 7 : 0) + m - r;
    return t.setUTCDate(t.getUTCDate() - D), t.setUTCHours(0, 0, 0, 0), t;
  }
  O.exports = o.default;
})(p, p.exports);
var A = p.exports;
export {
  A as s
};
